import React, { ReactNode, useEffect } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { twMerge } from "tailwind-merge";

interface ModalProps {
  children: ReactNode;
  onClose?: () => void;
  className?: string;
  contentClassName?: string;
  fullscreen?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  children,
  onClose,
  className,
  contentClassName,
  fullscreen = false,
}) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const modalRoot = document.querySelector(".modal-container") || document.body;

  const overlayClasses = twMerge(
    classNames(
      "fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999] flex items-center justify-center transition-opacity duration-300",
      className
    )
  );

  const contentClasses = twMerge(
    classNames(
      fullscreen
        ? "w-full h-full"
        : "relative bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden transform transition-all duration-300 scale-100",
      contentClassName
    )
  );

  return ReactDOM.createPortal(
    <div
      className={overlayClasses}
      onClick={onClose}
    >
      <div
        className={contentClasses}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    modalRoot
  );
};

export default Modal;
